var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email-7333583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 4.25H7C4.38 4.25 2.25 6.38 2.25 9V15C2.25 17.62 4.38 19.75 7 19.75H17C19.62 19.75 21.75 17.62 21.75 15V9C21.75 6.38 19.62 4.25 17 4.25ZM20.25 15C20.25 16.79 18.79 18.25 17 18.25H7C5.21 18.25 3.75 16.79 3.75 15V9C3.75 7.21 5.21 5.75 7 5.75H17C18.79 5.75 20.25 7.21 20.25 9V15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5801 8.37985L12.6901 11.6399C12.2701 11.9199 11.7201 11.9199 11.3001 11.6399L6.41008 8.37985C6.07008 8.14985 5.60008 8.23985 5.37008 8.58985C5.14008 8.93985 5.23008 9.39985 5.58008 9.62985L10.4701 12.8899C10.9301 13.1999 11.4601 13.3499 12.0001 13.3499C12.5401 13.3499 13.0601 13.1999 13.5301 12.8899L18.4201 9.62985C18.7601 9.39985 18.8601 8.92985 18.6301 8.58985C18.4001 8.24985 17.9301 8.14985 17.5901 8.37985H17.5801Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.c340927abdfa7c2acde21b3690254a2c.svg";
export { ForwardRef as ReactComponent };